import { render, staticRenderFns } from "./Consumed.vue?vue&type=template&id=72b80dd8&"
import script from "./Consumed.vue?vue&type=script&lang=js&"
export * from "./Consumed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports